import React, { useState } from "react";
import NxtbnModal from "../Modal";
import { InputField, NXForm } from "../common";
import useApi from "../../api";
import { toast } from "react-toastify";
import enumChoice from "../../enum";

interface FixedDateFormProps {
  order?: any;
  isOpen: boolean;
  onClose: () => void;
  fetchOrderDetails: () => void;
}

function FixedDateForm({
  order,
  isOpen,
  onClose,
  fetchOrderDetails,
}: FixedDateFormProps) {
  const [formData, setFormData] = useState<any>({
    due_date: "",
    payment_term: enumChoice.paymentTerms.toKV().FIXED_DATE.value,
  });
  const [errorData, setErrorData] = useState<any>(null);

  const api = useApi();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev:any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    api.updateOrderPaymentTerm(order.alias, formData).then((response) => {
        toast.success("Payment term updated successfully");
        fetchOrderDetails();
        onClose();
      }, (error) => {
        
      })
  };

  return (
    <NxtbnModal size="sm" isOpen={isOpen} onClose={onClose}>
      <div className="p-4">
        <h2 className="border-b pb-3">Fixed Due Date</h2>

        <NXForm
          className="mt-6"
          onSubmit={onSubmit}
          nonFieldError={errorData}
          showErrorPopup={true}
        >
          <div className="w-full">
            <InputField
              id="due_date"
              type="date"
              name="due_date"
              value={formData.due_date || ""}
              onChange={handleChange}
              placeholder="Enter fixed date"
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              errorData={errorData}
            />
          </div>

          <div className="flex justify-end mt-4">
            <button
              type="button"
              onClick={onClose}
              className="mr-2 px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-primary-600 hover:bg-primary-400 text-white rounded-md hover:bg-primary-700"
            >
              Save
            </button>
          </div>
        </NXForm>
      </div>
    </NxtbnModal>
  );
}

export default FixedDateForm;
